import { Component, OnInit, Optional, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MatDialogModule,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { InboxService } from '../../../inbox/inbox.service';
import { ToastrService } from 'ngx-toastr';
import { TransferModel, TransferProviderModel } from '../../transfer-model';
import { HttpErrorResponse } from '@angular/common/http';
import { CreateNewPatientModalService } from '../../create-new-patient-modal/create-new-patient-modal.service';

@Component({
  standalone: true,
  selector: 'app-patient-details-confirmation-modal',
  templateUrl: './patient-details-confirmation-modal.component.html',
  imports: [CommonModule, MatDialogModule],
})
export class PatientDetailsConfirmationModalComponent implements OnInit {
  title:string = 'Edit Confirmation';
  message:string = 'Are you sure you want to update patient details?';
  loading: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<PatientDetailsConfirmationModalComponent>,
    private toastr: ToastrService,
    private patientDetailService: CreateNewPatientModalService,
    @Optional()
    @Inject(MAT_DIALOG_DATA)
    public data: {
      updateValues: any,
      orgEntityId: string,
    }
  ) {}

  closeModal() {
    this.dialogRef.close();
  }
  ok() {
    this.loading = true;
    this.data.updateValues.stateOrProvinceCode =
    this.data.updateValues.stateOrProvinceCode
        ? this.data.updateValues.stateOrProvinceCode
        : ''
    const mergePatient = {
      firstName: this.data.updateValues.firstName,
      middleName: this.data.updateValues.middleName,
      lastName: this.data.updateValues.lastName,
      externalId: this.data.updateValues.externalId,
      patientId: this.data.orgEntityId,
      dateOfBirth: this.data.updateValues.dateOfBirth,
      cellPhone: this.data.updateValues.patientPhoneNumber,
      homePhone: this.data.updateValues.patientHomePhoneNumber,
      email: this.data.updateValues.patientEmail,
      address: {
        addressLine1: this.data.updateValues.addressLine1,
        addressLine2: this.data.updateValues.addressLine2,
        city: this.data.updateValues.city,
        postalCode: this.data.updateValues.postalCode,
        stateOrProvinceCode: this.data.updateValues.stateOrProvinceCode,
      },
      }
      this.patientDetailService
        .mergePatientDetails(mergePatient, this.data.updateValues.orgEntityId)
        .subscribe({
          next: (result: any) => {
              this.loading = false;
              this.toastr.success('Patient Detail Updated Successful');
              this.dialogRef.close({success: true, orgEntityId: this.data.updateValues.orgEntityId});
          },
          error: (error: HttpErrorResponse) => {
            this.loading = false;
            this.toastr.error(error.error.message || error?.error?.Error ||  'Something went error');
          },
        });
    
  }
  ngOnInit(): void {
  }
}
